import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../../../assets/images/inferenz-logo.svg'
import { useNavigate } from 'react-router-dom'
import { BsPersonCircle } from 'react-icons/bs'
import 'tippy.js/dist/tippy.css'
import { CgProfile } from 'react-icons/cg'
import { AiOutlineUserSwitch } from 'react-icons/ai'
import { FiLogOut } from 'react-icons/fi'

export const Header = () => {
  const navigate = useNavigate()
  const logout = () => {
    localStorage.clear()
  }
  return (
    <div>
      <nav className="navbar navbar-expand-lg fixed-top ">
        <div className="container">
          <Link className="link" to="/interviewerDashboard">
            <img src={logo} alt="logo" className="headerLogo" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarResponsive"
            aria-controls="navbarResponsive"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarResponsive">
            <ul className="navbar-nav ms-auto">
              <li
                className="nav-item"
                style={{
                  fontSize: '18px',
                  fontWeight: 500,
                  marginRight: '1rem',
                }}
              >
                <Link
                  className="nav-link"
                  to="/interviewerDashboard"
                  id="homenav"
                >
                  Home
                </Link>
              </li>
              <li
                className="nav-item"
                style={{
                  fontSize: '18px',
                  fontWeight: 500,
                  marginRight: '1rem',
                }}
              >
                <Link
                  className="nav-link"
                  to="/interviewHistory"
                  id="historynav"
                >
                  History
                </Link>
              </li>
            </ul>
          </div>

          <ul className="navbar-nav mb-2 mb-lg-0">
            <li className="nav-item dropdown">
              <BsPersonCircle
                style={{
                  width: '25px',
                  height: '25px',
                  marginTop: '0.3rem',
                  marginRight: '1rem',
                  color: '#0d6efd',
                }}
                className="rounded-circle"
                height="35"
                alt="Black and White Portrait of a Man"
                loading="lazy"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              />

              <ul className="dropdown-menu">
                <Link to="/profile" className="link">
                  <li
                    className="mx-2 d-flex"
                    style={{ cursor: 'pointer', height: '0.8rem' }}
                  >
                    <CgProfile size={18} className="mt-1" />
                    <h6 className="mt-1 mx-2">My Profile</h6>
                  </li>
                </Link>
                <hr />
                <Link to="/portal" className="link">
                  <li
                    className="mx-2 d-flex"
                    style={{ cursor: 'pointer', height: '0.8rem' }}
                  >
                    <AiOutlineUserSwitch size={18} />
                    <h6 className="mt-1 mx-1">Switch portal</h6>
                  </li>
                </Link>
                <hr />
                <li
                  data-bs-target="#exampleModal"
                  data-bs-toggle="modal"
                  className="mx-2 d-flex align-items-center"
                  style={{ cursor: 'pointer', height: '0.8rem' }}
                >
                  <FiLogOut size={15} /> <h6 className="mt-2 mx-2">Logout</h6>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
      <div
        className="modal"
        tabIndex="-1"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Alert</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to Logout from Intranet ?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  logout()
                  navigate('/')
                }}
                data-bs-dismiss="modal"
              >
                Yes
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
